import api from './api';
import { authStorage, StoredSession } from './authStorage';

export interface AuthProfile {
  id?: number;
  username: string;
  role: string;
  email?: string | null;
  nom?: string | null;
  mustChangePassword: boolean;
}

export interface LoginResult extends AuthProfile {
  token: string;
}

export const authService = {
  login: async (username: string, password: string): Promise<LoginResult> => {
    const response = await api.post<LoginResult>('/api/auth/login', { username, password });
    await authStorage.save({
      token: response.data.token,
      username: response.data.username,
      role: response.data.role,
      mustChangePassword: response.data.mustChangePassword,
    });
    return response.data;
  },

  me: async (): Promise<AuthProfile> => {
    const response = await api.get<AuthProfile>('/api/auth/me');
    const current = await authStorage.load();
    await authStorage.save({
      token: current.token,
      username: response.data.username,
      role: response.data.role,
      mustChangePassword: response.data.mustChangePassword,
    });
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<AuthProfile> => {
    const response = await api.post<AuthProfile>('/api/auth/change-password', {
      currentPassword,
      newPassword,
    });
    const current = await authStorage.load();
    await authStorage.save({
      token: current.token,
      username: response.data.username,
      role: response.data.role,
      mustChangePassword: response.data.mustChangePassword,
    });
    return response.data;
  },

  logout: async () => {
    // Archive the logout server-side (best effort: never block the local logout).
    try {
      if (await authStorage.getToken()) await api.post('/api/auth/logout', undefined, { timeout: 4000 });
    } catch {
      // Offline or expired session: nothing to archive.
    }
    await authStorage.clear();
  },

  getToken: () => authStorage.getToken(),

  getStoredSession: (): Promise<StoredSession> => authStorage.load(),
};
